import React from "react";
import {ProductData} from "@/types/product";
import assignBundleItems from "@/services/ProductService/assignBundleItems";
import store from "@/store";
import {snapshot} from "valtio";
import updateProductInLocal from "@/services/ProductService/updateProductInLocal";
import getBundleItems from "@/services/ProductService/getBundleItems";
const selectProductForBundleStates = {


    checkDuplicate: {
        main: async (data: any, defaultData: { selectedProduct: { product_id: string; quantity: number }; productId: string }) => {
            const { products } = snapshot(store);
            const currentProduct = products.find(
                p => p.product_id === defaultData.productId
            ) as ProductData | undefined;
            const isDuplicate = currentProduct?.bundle?.items.some(
                item => item.product_id === defaultData.selectedProduct.product_id
            );
            if (isDuplicate) {
                throw new Error('Product is already in the bundle');
            }
        },
        startMessage: () => 'Check bundle item ...',
        errorMessage: (error: any) => `${error?.message || error} :(`,
    },
    assignBundleItem: {
        main: async (data: any, defaultData: { selectedProduct: { product_id: string; quantity: number }; productId: string, bundleId: string | null }) => {
            return await  assignBundleItems(
                [
                    {
                        product_id: defaultData.selectedProduct.product_id,
                        quantity: Number(defaultData.selectedProduct.quantity),
                    }
                ],
                defaultData.productId,
                defaultData.bundleId
            );
        },
        startMessage: () => 'Assign bundle item ...',
        errorMessage: (error: any) => `${error?.message || error} :(`,
    },



    updateProductList: {
        main: async (data: any, defaultData: { productId: string, selectedProduct: { product_id: string; quantity: number } }) => {
            console.log(data)
            const { products } = snapshot(store);
            /*const index = products.findIndex(p => p.product_id === defaultData.productId);

            if (index === -1) {
                console.error(`Product with ID ${defaultData.productId} not found.`);
                return;
            }*/

            let currentProduct = products.find(
                p => p.product_id === defaultData.productId
            ) as ProductData | undefined;

            if (!currentProduct) return;
            const getBundle = await getBundleItems(data.assignBundleItem)
            const bundleList = getBundle.bundle_items.map((item: any) => {
                return {
                    "2d_image_url" : item?.["2d_image_url"],
                    id: item.product_id,
                    name: item.name,
                    product_id: item.product_id,
                    product_profile_id: item.product_profile_id,
                    quantity: item.quantity,
                    sku: item.sku,
                }
            })
            const updateCurrentProduct: ProductData = {
                ...currentProduct,
                is_bundle: true,
                bundle: {
                    id: data.assignBundleItem,
                    items: bundleList
                },
            };

            updateProductInLocal(updateCurrentProduct);
            /*const updatedProduct: ProductData = {
                ...currentProduct,
                is_bundle: true,
                sections: currentProduct.sections.map((section) => ({ ...section })) as ProductSectionData[],
                bundle: {
                    id: data.id,
                    items: [
                        currentProduct?.bundle?.items.length ? ...currentProduct?.bundle?.items : ...[],
                        {
                            product_id: data.bundle_product_ids[0]?.product_id,
                            quantity: data.bundle_product_ids[0]?.quantity,
                        },
                    ],
                },
            };

            store.products = products.map((p, i) => (i === index ? updatedProduct : p)) as ProductData[];*/
        },
        startMessage: () => `Load products ...`,
        errorMessage: () => `Loading failed :(`
    }





}

export default selectProductForBundleStates